export const youtubeParser = (url) => {
  const result =
    /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm.exec(
      url
    );
  return result ? result[3] : null;
};
